export default "__VITE_ASSET__ed7240b3__"